import { render } from "./Stats.vue?vue&type=template&id=7666dc56"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/application/Stats.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7666dc56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7666dc56', __exports__)) {
    api.reload('7666dc56', __exports__)
  }
  
  module.hot.accept("./Stats.vue?vue&type=template&id=7666dc56", () => {
    api.rerender('7666dc56', render)
  })

}


export default __exports__